import PropTypes from 'prop-types'
import StudentCard from './StudentCard'
import ProgramCard from './ProgramCard'
import { DUAL_PANEL_SELECTABLE_TYPES, ItemCardProps } from '../../../../constants/dual-panel-selector-constants'
import SeriesCard from './SeriesCard'
import EventCard from './EventCard'
import CoachCard from './CoachCard'

const ItemCard = ({ type, ...props }) => {

  switch (type) {
    case DUAL_PANEL_SELECTABLE_TYPES.students:
      return <StudentCard {...props} />
    case DUAL_PANEL_SELECTABLE_TYPES.coaches:
      return <CoachCard {...props} />
    case DUAL_PANEL_SELECTABLE_TYPES.programs:
      return <ProgramCard {...props} />
    case DUAL_PANEL_SELECTABLE_TYPES.programsWithPackages:
      return <ProgramCard withAdditionalSelect {...props} />
    case DUAL_PANEL_SELECTABLE_TYPES.series:
      return <SeriesCard {...props} />
    case DUAL_PANEL_SELECTABLE_TYPES.programsWithAnnouncement:
      return <EventCard {...props} />
    default:
      return null
  }
}

ItemCard.propTypes = {
  ...ItemCardProps,
  type: PropTypes.oneOf(Object.values(DUAL_PANEL_SELECTABLE_TYPES)),
}

export default ItemCard
